module.exports = __webpack_public_path__ + "media/assets/faria_products/check_icon-a6ac4921a3b9350cb304a7ac15d736fdc2e36375ff42f3ddb14ae81a237647c5.svg";